export async function fetchRecaptchaToken(action) {
  return new Promise(async (resolve, _) => {
    grecaptcha.ready(async () => {
      let token = await grecaptcha.execute(window.RECAPTCHA_SITE_KEY, {action: action})
      return resolve(token)
    })
  })
}
